import { z } from 'zod'

export const updateTbankConnectionSchema = z.object({
  name: z.string().min(1).max(50).optional(),
  token: z.string().min(10).max(200).optional(), // token rotation
})

export type UpdateTbankConnectionDto = z.infer<typeof updateTbankConnectionSchema>
